import { ObjectType } from '@xbcb/shared-types';
import { capitalCase } from 'change-case';
import { createModalKey, ModalKey } from 'types';

export const generateCreateModalKey = (objectType: ObjectType): ModalKey =>
  createModalKey(`CREATE_${capitalCase(objectType).replace(/\s/g, '')}`);
